/** Browser-local display only; numeric units are explicit, never inferred from magnitude. */
export function renderDateTimeValue(value: unknown, numericUnit: 'milliseconds' | 'seconds' = 'milliseconds', locale?: string): string {
  if (numericUnit !== 'milliseconds' && numericUnit !== 'seconds') return '—';
  let instant: number;
  if (typeof value === 'number') {
    instant = numericUnit === 'seconds' ? value * 1000 : value;
  } else if (typeof value === 'string') {
    // Require a timezone so a server-produced value cannot silently become local wall time.
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
    if (!match) return '—';
    const year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
    const hour = Number(match[4]), minute = Number(match[5]), second = Number(match[6]);
    const calendar = new Date(0);
    calendar.setUTCFullYear(year, month - 1, day);
    if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day || hour > 23 || minute > 59 || second > 59) return '—';
    instant = Date.parse(value);
  } else return '—';
  if (!Number.isFinite(instant)) return '—';
  const date = new Date(instant);
  if (!Number.isFinite(date.getTime())) return '—';
  try { return date.toLocaleString(locale); } catch { return '—'; }
}
